import {
  GenericGIType,
  GITypeDisplay,
  type GroundInvestigationPoint
} from '@/stores/type/giPoint.type'

export function getGIDipslayName(giPoint?: GroundInvestigationPoint): GITypeDisplay {
  const mapping: Partial<Record<GenericGIType, GITypeDisplay>> = {
    [GenericGIType.BOREHOLE_GENERIC]: GITypeDisplay.BOREHOLE,
    [GenericGIType.CPT_GENERIC]: GITypeDisplay.CPT
  }
  return mapping[giPoint?.properties.generic_gi_type as GenericGIType] ?? GITypeDisplay.UNKNOWN
}
